var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"b-popover",rawName:"v-b-popover.hover",value:(_vm.tooltip),expression:"tooltip",modifiers:{"hover":true}}],staticClass:"tooltip-wrapper"},[_c('span',{staticClass:"fa fa-info-circle"})])}
var staticRenderFns = []

export { render, staticRenderFns }